module.exports = __webpack_public_path__ + "media/images/icons/play-14c0ba1fea51bec66933fe78cd286407.svg";